import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import {observer, inject} from 'mobx-react';
import {Link} from 'react-router-dom';
import intl from 'react-intl-universal';
import queryString from 'query-string';

import Button from "../../../../components/Button";

import DrawerButton from "../DrawerButton";
import LayerToggle from "../LayerToggle";
import DrawerContainer from "../DrawerContainer";
import MapButtons from "../MapButtons";
import EmptyResponseMessage from '../EmptyResponseMessage';

import './BottomContainerMobile.css';

@inject("appStore")
@observer
class BottomContainerMobile extends Component {
    constructor(props) {
        super(props);
        this.hideFinishButton = !!queryString.parse(document.location.search).hideMapFinishBtn;

        this.state = {
            emptyResponse: !!(props.emptyResponseRoute && this.props.appStore.appConfig.map.bypassMode),
        };
    }

    getComp = () => {
        if (this.props.appStore.hasDemographics()) {
            const mapContent = this.props.appStore.appConfig.content.map;

            return this.props.appStore.appConfig.map.bypassMode && this.props.appStore.elementStore.elements.length < 1 ? (
                <div
                    className={'finishedButton' + (this.props.appStore.drawer.open ? ' drawer-open ' : '')}
                    onClick={() => this.setState({ emptyResponse: true })}>
                        {mapContent['finish_button']}
                    </div>
            ) : (
                <Link to={`/survey`}>
                    <Button className={'finishedButton ' + (this.props.appStore.drawer.open ? 'drawer-open' : '')+ ((this.props.appStore.editMode || this.props.appStore.elementStore.elements.length < 1) ? ' editMode ' : '')}>
                        {mapContent['finish_button']}
                    </Button>
                </Link>
            );
        } else {
            return (<div
                onClick={() => this.props.appStore.submitData('', (responseVal) => {
                    if (responseVal) {
                        console.log('inside getComp: BottomContainerMobile: ' + responseVal);
                        this.props.navigate('/end');

                    } else {
                        this.props.navigate('/error');
                    }
                })}>
                <Button className={'finishedButton ' + (this.props.appStore.drawer.open ? 'drawer-open' : '')}>
                    {'Submit'}
                </Button>
            </div>);
        }
    };

    componentDidUpdate() {
        if (this.props.emptyResponseRoute && this.props.appStore.appConfig.map.bypassMode && !this.state.emptyResponse) {
            this.setState({ emptyResponse: true });
        }
    }

    render() {
        let questionTypes = Object.keys(this.props.appStore.appConfig.questions).filter((type) => this.props.appStore.appConfig.questions[type].length > 0);

        return (
            <div className="BottomContainerMobile">
                {this.props.appStore.appConfig.map.bypassMode && <EmptyResponseMessage visible={this.state.emptyResponse} setVisible={visible => this.setState({ emptyResponse: visible })}/>}

                {this.props.appStore.appConfig.map.zoomLocations &&
                this.props.appStore.appConfig.map.zoomLocations.length > 0 &&
                <MapButtons/>}

                {!this.props.appStore.appConfig.map.nonSpatial && Object.keys(this.props.appStore.appConfig.map.baseLayers).length > 1 &&
                    <LayerToggle/>}

                {!this.props.appStore.pendingState.savePopup && !this.props.appStore.pendingState.confirmationPopup &&
                <div className="bottomContainer">
                    <div className="drawerButtons">
                        {questionTypes.map((type, index) =>
                            <DrawerButton key={type}
                                          questionType={type}>
                                {type}
                            </DrawerButton>
                        )}
                    </div>
                    {!this.hideFinishButton && this.getComp()}
                </div>}

                {this.props.appStore.drawer.open &&
                <DrawerContainer/>
                }
            </div>
        );
    }
}

export default BottomContainerMobile;



// WEBPACK FOOTER //
// ./src/scenes/MapContainer/components/BottomContainerMobile/index.js